import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';

import { ChatTraceResponse, getChatTrace } from '~/services/TripPlannerService';

import { tripPlannerQueryKeys } from './tripPlannerQueryKeys';

const combinePages = ({ pages }: InfiniteData<ChatTraceResponse, string | undefined>) => ({
  ...pages[0],
  result: {
    ...pages[0].result,
    hasMore: pages[pages.length - 1].result.hasMore,
    nextCursor: pages[pages.length - 1].result.nextCursor,
    turns: pages.flatMap((page) => page.result.turns),
    unassignedItems: pages.flatMap((page) => page.result.unassignedItems),
  },
});

export function useGetChatTrace(chatId?: string) {
  return useInfiniteQuery({
    queryKey: [...tripPlannerQueryKeys.all, 'chat-trace-forward-pages', chatId],
    queryFn: ({ signal, pageParam }: { signal: AbortSignal; pageParam: string | undefined }) =>
      getChatTrace(chatId ?? '', { signal, after: pageParam }),
    initialPageParam: undefined,
    getNextPageParam: (page) => page.result.nextCursor ?? undefined,
    select: combinePages,
    enabled: Boolean(chatId),
    retry: false,
    refetchOnWindowFocus: false,
  });
}
